import React from "react";
import { FaGraduationCap } from "react-icons/fa";
import Title from "../layouts/Title";
import Reveal from "../layouts/Reveal";
import { educationData, experienceData, yearsOfExperience } from "../../constants";

const Experience = () => {
  return (
    <section id="experience" className="sectionWrap">
      <Title title={`${yearsOfExperience} Years of Experience`} des="Where I've Delivered" />
      <div className="relative max-w-5xl mx-auto">
        <span className="absolute left-[11px] mdl:left-[191px] top-2 bottom-2 w-[2px] bg-gradient-to-b from-designColor via-designColor/30 to-transparent"></span>
        <div className="flex flex-col gap-10">
          {experienceData.map(({ role, company, period, location, points }, index) => (
            <Reveal key={company} delay={index * 0.1}>
              <div className="relative flex flex-col mdl:flex-row gap-3 mdl:gap-12 pl-10 mdl:pl-0 group">
                <div className="mdl:w-[160px] shrink-0 whitespace-nowrap mdl:text-right pt-1">
                  <p className="text-sm text-designColor font-medium tracking-wide">{period}</p>
                  <p className="text-xs text-gray-500 mt-1">{location}</p>
                </div>
                <span className="absolute left-0 mdl:left-[180px] top-1 w-6 h-6 rounded-full bg-bodyColor border-2 border-designColor flex items-center justify-center">
                  <span className={`w-2 h-2 rounded-full ${index === 0 ? "bg-designColor animate-pulse" : "bg-gray-500 group-hover:bg-designColor"} duration-300`}></span>
                </span>
                <div className="card p-6 md:p-8 flex-1 group-hover:border-designColor/40 duration-300">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <h3 className="text-xl md:text-2xl font-semibold text-white font-titleFont">{role}</h3>
                    {index === 0 && <span className="chip text-designColor border-designColor/40">Current</span>}
                  </div>
                  <p className="text-gray-300 mt-1">{company}</p>
                  <ul className="mt-4 flex flex-col gap-3">
                    {points.map((point) => (
                      <li key={point} className="flex gap-3 text-gray-400 leading-7 text-sm md:text-base">
                        <span className="mt-[11px] w-1.5 h-1.5 rounded-full bg-designColor shrink-0"></span>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16">
          <h3 className="text-xs uppercase tracking-[3px] text-gray-500 mb-4 flex items-center gap-2">
            <FaGraduationCap className="text-designColor text-base" /> Education
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {educationData.map(({ degree, school, period }) => (
              <div key={degree} className="card px-5 py-4 flex items-center justify-between gap-4">
                <div>
                  <p className="text-white font-medium">{degree}</p>
                  <p className="text-sm text-gray-400">{school}</p>
                </div>
                <p className="text-xs text-gray-500 shrink-0">{period}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Experience;
